import { render, staticRenderFns } from "./SettingsRest.vue?vue&type=template&id=67815ca4"
import script from "./SettingsRest.vue?vue&type=script&lang=js"
export * from "./SettingsRest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports